import { render, staticRenderFns } from "./CampoTipoVenta.vue?vue&type=template&id=f8d6e7ca"
import script from "./CampoTipoVenta.vue?vue&type=script&lang=js"
export * from "./CampoTipoVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports